import type { CarrierRateRow } from './freight-rate-card-types';
import type { LtlQuote } from '../../types/ltl';

export const RATE_SERVICE_TYPE_FILTER = {
  Direct: 'direct',
  Indirect: 'indirect',
} as const;
export type RateServiceTypeFilter = (typeof RATE_SERVICE_TYPE_FILTER)[keyof typeof RATE_SERVICE_TYPE_FILTER];

export type RateFilters = {
  serviceType: RateServiceTypeFilter | null;
};

export const DEFAULT_RATE_FILTERS: RateFilters = { serviceType: null };

const VALID_SERVICE_TYPES: Set<string> = new Set(Object.values(RATE_SERVICE_TYPE_FILTER));

export const isRateServiceTypeFilter = (value: unknown): value is RateServiceTypeFilter =>
  typeof value === 'string' && VALID_SERVICE_TYPES.has(value);

export const countActiveRateFilters = (filters: RateFilters): number => (filters.serviceType === null ? 0 : 1);

const normalizeServiceType = (value: string | null | undefined): string => (value ?? '').trim().toLowerCase();

const rowMatchesServiceType = (row: CarrierRateRow, wanted: RateServiceTypeFilter): boolean =>
  [row.standard, row.guaranteed]
    .filter((slot): slot is LtlQuote => slot !== null)
    .some((slot) => normalizeServiceType(slot.serviceType) === wanted);

export const filterCarrierRows = (rows: CarrierRateRow[], filters: RateFilters): CarrierRateRow[] => {
  const { serviceType } = filters;
  if (serviceType === null) return rows;
  return rows.filter((row) => rowMatchesServiceType(row, serviceType));
};
